import { Dispatch } from "redux";
import { Row } from "../models/rowModel";
import {
  ADD_ROW,
  ADD_ROW_LIST,
  AppActions,
  EDIT_ROW,
  MOVE_ROW,
  REMOVE_ALL_ROWS,
  REMOVE_ROW,
  REMOVE_ROW_BY_TAB_ID,
  REMOVE_ROW_LIST_BY_FORM_ID,
  SET_ROW,
} from "../types/actions";
import { AppState } from "../reducers/rootReducer";
import { uuid } from "uuidv4";
import { addSection } from "./sectionListAction";
import rowService from "../services/rowServices";
import sectionService from "../services/sectionService";
import App from "../App";

export const addRow = (row: Row): AppActions => ({
  type: ADD_ROW,
  row,
});

export const addRows = (rows: Row[]): AppActions => ({
  type: ADD_ROW_LIST,
  rows,
});

export const editRow = (row: Row): AppActions => ({
  type: EDIT_ROW,
  row,
});

export const removeRow = (id: String): AppActions => ({
  type: REMOVE_ROW,
  id,
});

export const removeRowListByFormId = (formId: String): AppActions => ({
  type: REMOVE_ROW_LIST_BY_FORM_ID,
  formId,
});

export const setRow = (rows: Row[]): AppActions => ({
  type: SET_ROW,
  rows,
});

export const moveRow = (rowDrag: Row, rowDrop: Row): AppActions => ({
  type: MOVE_ROW,
  rowDrag,
  rowDrop,
});

export const removeAllRows = (rows: Row[]): AppActions => ({
  type: REMOVE_ALL_ROWS,
  rows,
});

// start adding row to redux store

export const startAddRow = (
  rowData: {
    type: string;
    formId: String;
    tabId: String;
    sortKey: number;
    rowHighlight: boolean;
    height: string;
    width: string;
    verticalAlign: string;
    horizontalAlign: string;
    cssStyles: [any];
    remark1: string;
    remark2: string;
    remark3: string;
    remark4: string;
    createdTime: string;
    lastUpdatedTime: string;
  },
  sectionCount: number
) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const {
      type = "form",
      formId = "1",
      tabId = "",
      sortKey = 0,
      rowHighlight = true,
      height = "",
      width = "",
      verticalAlign = "",
      horizontalAlign = "",
      cssStyles = [{}],
      remark1 = "",
      remark2 = "",
      remark3 = "",
      remark4 = "",
      createdTime = "",
      lastUpdatedTime = "",
    } = rowData;

    const row = {
      type,
      formId,
      tabId,
      sortKey,
      rowHighlight,
      height,
      width,
      verticalAlign,
      horizontalAlign,
      cssStyles,
      remark1,
      remark2,
      remark3,
      remark4,
      createdTime,
      lastUpdatedTime,
    };
    const id = uuid();

    const { data } = await rowService.createRow({
      id,
      ...row,
    });

    dispatch(addRow(data.data));

    // let sectionSize = 12

    for (let index = 0; index < sectionCount; index++) {
      let sectiondId = uuid();

      const { data } = await sectionService.createSection({
        id: sectiondId,
        rowId: id,
        formId: formId,
        sortKey: index,
        tempHiglight: true,
        sectionRowVerticalAlignment: "",
        sectionRowHorizontalAlignment: "",
        inline: false,
        responsiveXs: 0,
        responsiveMd: 0,
        responsiveLg: 0,
        responsiveSm: 0,
        cssStyles: cssStyles,
        createdTime: "",
        lastUpdatedTime: "",
      });
      dispatch(addSection(data.data));
    }
  };
};

// start edit row from redux store

export const startEditRow = (row: Row) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    rowService.updateRow(row);
    dispatch(editRow(row));
  };
};

// start remove row from redux store

export const startRemoveRow = (id: String) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    dispatch(removeRow(id));
  };
};

// start select all rows from redux store

export const startSetRow = (rows: Row[]) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    dispatch(setRow(rows));
  };
};

export const startMoveRow = (rowDrag: Row, rowDrop: Row) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    dispatch(moveRow(rowDrag, rowDrop));
    const rows = getState().rowList;
    rowService.moveRows(rows);
  };
};
